import { createContext, useEffect, useState } from "react";
import { getAnnouncements, getPlaceInfo } from "../api/api";
import { useHistory } from "react-router-dom";

const SchoolContext = createContext({});

const SchoolProvider = (props) => {

    const [school, selectSchool] = useState(null);
    const [schoolList, setSchoolList] = useState([]);
    const [loading, setLoading] = useState();
    const [message, setMessage] = useState(null);
    const authToken = localStorage.getItem('accessToken')
    const history = useHistory();
    const pathname = history["location"].pathname
    const school_id = Number(pathname.split('/').pop());
    console.log('message', message)
    useEffect(() => {
        if (school !== null && !Number.isNaN(school_id)) {
            const authToken = localStorage.getItem('accessToken');
            const placeId = school.place_id;
            const fetchAnnouncements = async () => {
                const res = await getAnnouncements(authToken, placeId);
                setMessage(res.data);
                // setMessage([{
                //     id: 1,
                //     target_time: '2024/2/20 9:00',
                //     title: "お知らせ機能追加に関して",
                //     content: "いつも大変お世話になっております。 \r\n <a href=\"https://www.smartsolar.co.jp/\"></a>"
                // },
                // {
                //     id: 2,
                //     target_time: '2024/2/20 11:00',
                //     title: "遠隔監視システムのメンテナンス日程に関して",
                //     content: "このサイトでは各発電所の情報を確認できます。\r\n <a href=\"https://www.smartsolar.co.jp/\"></a>"
                // }
                // ])
            }
            fetchAnnouncements();
        }
    }, [school, school_id]);

    useEffect(() => {
        const selectedSchool = schoolList[school_id - 1] || null;

        // const schoolListCached = localStorage.getItem('curr_list') || null;  


        // if (schoolListCached !== null) {
        //     setSchoolList(JSON.parse(schoolListCached));
        // }

        setLoading(true);
        const fetchPlaceInfo = async () => {
            const data = await getPlaceInfo(authToken)
            setSchoolList(data);
            setLoading(false);

            if (selectedSchool !== null) {
                const school = data.filter(el => el.id === +selectedSchool);
                if (!!school.length) {
                    selectSchool(school[0]);
                }
            } else {
                selectSchool(null)
            }
        };

        fetchPlaceInfo();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        const selectedSchool = schoolList[school_id - 1] || null;

        if (selectedSchool !== null) {
            const school = schoolList.filter(el => el.id === +selectedSchool);
            if (!!school.length) {
                selectSchool(school[0]);
            }
        }
    }, [schoolList, school_id]);

    const setSchool = (val) => {
        const school = schoolList.filter((el) => el.id === val);
        if (!!school.length) {
            selectSchool(school[0]);
            localStorage.setItem('curr_school', school[0].id);
        }
    };

    // const addToSchoolList = (school) => {
    //     const lastId = schoolList[schoolList.length - 1].id
    //     school.id = lastId + 1;
    //     setSchoolList([...schoolList, school]);
    //     localStorage.setItem('curr_list', JSON.stringify([...schoolList, school]));
    // };

    const addToSchoolList = (school) => {
        const updatedSchoolList = schoolList.filter(el => el.id !== school.id);
        updatedSchoolList.push(school);
        updatedSchoolList.sort((a, b) => a.id - b.id);
        setSchoolList(updatedSchoolList);
    }

    return <SchoolContext.Provider value={{ school, schoolList, setSchool, addToSchoolList, loading, message, setMessage }}>
        {props.children}
    </SchoolContext.Provider>
};

export { SchoolContext, SchoolProvider };